/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./App.css";
import "./app.scss";
import { BrowserRouter } from "react-router-dom";
import AuthenticationRoutes from "./routes/AuthenticationRoutes";
import BuyerRoutes from "./routes/BuyerRoutes";
import SellerRoutes from "./routes/SellerRoutes";
import { useDispatch, useSelector } from "react-redux";
import { getCountForHeader, getProfile } from "./store/actions/profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { USER_TYPE } from "./constants/constants";
import { verifySubscription } from "./store/actions/subscription";
import ProviderRoutes from "./routes/ProviderRoutes";
import Loader from "./view/common/component/Loader";
import { getSupportInfo } from "./store/actions/auth";

function App() {
  const dispatch: any = useDispatch();

  const { profile, isSubscribed, isProfileError, } = useSelector((state: any) => ({
    profile: state?.profile?.profile,
    isSubscribed: state?.subscription?.isSubscribed,
    isProfileError: state?.profile?.error,
  }));

  const handleNotificationCount = async () => {
    try {
      await dispatch(getCountForHeader());
    } catch (error) {
    }
  };

  useEffect(() => {
    dispatch(getProfile());
    dispatch(getSupportInfo());
  }, []);

useEffect(()=>{
  if((profile !== null) && (isSubscribed === null || isSubscribed === undefined)) dispatch(verifySubscription());
  let setIntervalId = profile && setInterval(handleNotificationCount, 5 * 60 * 1000);

  return () => {
    clearInterval(setIntervalId);
  }
},[profile]);

// To show loading while retrieving the profile data through the API.
if(
    localStorage.getItem("m-market-user-token") &&
    !profile &&
    !isProfileError &&
    
    /*
      After the 'signUp' API succeeds, the token is available & profile is not.
      At that time, we have the next steps to show in the 'Sign up' process.
      So, to avoid showing this loader
    */
    (window.location.href.split("/").reverse()[0] !== "sign-up") &&
    /*
      As for the new flow, after entering the ph. no & password, otp gets generated.
      So, to avoid showing this loader
    */
    (window.location.href.split("/").reverse()[0] !== "sign-in")
  ){
  return <Loader />;
};

  return (
    <BrowserRouter basename={`/${process.env.PUBLIC_URL}`}>
      {profile ? (
        profile?.type === USER_TYPE.BUYER ? (
          <BuyerRoutes /> 
        ) : (
          profile?.type === USER_TYPE.SELLER ?
          <SellerRoutes /> : <ProviderRoutes />
        )
      ) : (
        <AuthenticationRoutes />
      )}
      <ToastContainer
       position="top-right"
       autoClose={5000}
       hideProgressBar={false}
       newestOnTop={false}
       closeOnClick
       rtl={false}
       pauseOnFocusLoss
       draggable
       pauseOnHover
       theme="colored"
      />
    </BrowserRouter>
  );
}

export default App;
